import classnames from "classnames";
import { parse } from "date-fns";
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Button, Col, Container, Form, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, Row, Spinner, TabContent, TabPane } from 'reactstrap';
import { axios } from "~/apicall";
import TimerItem from './components/TimerItem';
import StageComponent from "~/components/location/StageComponent.js";
import moment from "moment";
import "moment/locale/id"; 
export class TimerList extends Component {
   

    state = {
        activeTab: 'timer',
        overtimeTarget: undefined,
        overtimeAmount: undefined
    }


    myRef = React.createRef();

    updateTimer = undefined;


    componentWillUnmount() {
        if (this.updateTimer) {
            clearInterval(this.updateTimer);
        }
    }

    componentDidMount() {
        const { adminStore } = this.props;
        console.log(adminStore._exams);
        if (adminStore.isLoading) {
            adminStore.examFetchScreenMode().then(() => {
                adminStore.armedExam.forEach(exam => {
                    if (exam?.time_left > 0) {
                        this.setState({ activeTab: "timer" });
                    }
                });
            });
            adminStore.fetchProfile();
        }

        // Setup timer.
        if (this.updateTimer) {
            clearInterval(this.updateTimer);
        }
        this.updateTimer = setInterval(() => {
            adminStore.examFetchScreenMode(false);
        }, 10000);
    }

    handleTimerPlayClick(exam) {
        const { adminStore } = this.props;
        axios.post("manage/exam/" + exam._id + "/start").then(() => {
            adminStore.examFetchScreenMode(exam._id);
        })
    }

    handleTimerStopClick(exam) {
        const { adminStore } = this.props;
        axios.post("manage/exam/" + exam._id + "/close").then(() => {
            adminStore.examFetchScreenMode(exam._id);
        })
    }

    handleTimerResetClick(exam) {
        const { adminStore } = this.props;
        axios.delete("manage/exam/" + exam._id + "/start").then(() => {
            adminStore.examFetchScreenMode(exam._id);
        })
    }

    handleTimerOvertimeClick(exam) {
        this.setState({ overtimeTarget: exam });
    }

    handleTimerOvertimeAction(e) {
        const { adminStore } = this.props;
        e.preventDefault();
        const { overtimeAmount, overtimeTarget } = this.state;
        let sourceTime = parse(overtimeTarget.time_ended, "yyyy-MM-dd HH:mm:ss", new Date());

        // TODO: check overtimeAmount.
        sourceTime.setTime(sourceTime.getTime() + overtimeAmount * 60000);

        console.log("updated time: ", sourceTime);
        axios.put("manage/exam/" + overtimeTarget._id, {
            ...overtimeTarget,
            _id: undefined,
            answer_slot: undefined,
            participants: undefined,
            exam_report: undefined,
            lecture: undefined,
            lecture_period: undefined,
            deleted_on: undefined,
            updated_on: undefined,
            created_on: undefined,
            time_left: undefined,
            online_participants: undefined,
            online_answer_slot: undefined,
            lecturers: undefined,
            resource: undefined,
            notification: undefined,
            time_ended: sourceTime.getTime() / 1000
        }).then(() => {
            adminStore.examFetchScreenMode(false);
            this.setState({ overtimeAmount: 0, overtimeTarget: undefined });
        })
    }


    render() {
        const { adminStore = {} } = this.props;
        const { armedExam } = adminStore;
        const { activeTab, overtimeTarget, overtimeAmount } = this.state;
        
        const todayStart = moment().startOf('day').valueOf();
        const todayEnd = moment().endOf('day').valueOf();
        
        if (adminStore.isLoading) {
            return this.renderLoaderScreen();
        }

        if (adminStore.loginType !== "ip") {
            return this.renderErrorScreen("This login method doesn't support this function, please login with IPLogin to get started.", (
                <Button color="primary" tag={Link} to="/admin/account/login">Logout and Login</Button>
            ))
        }

        if (adminStore.boundedLocations?.length === 0) {
            return this.renderErrorScreen("This IP is not connected with any rooms. Please contact administrator.")
        }

        return (
            <Container>
                <Row className="h-100vh align-items-center justify-content-center text-center">
                    <Col>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === 'seatmap' })}
                                    onClick={() => this.setState({ activeTab: 'seatmap' })}
                                >
                                    SeatMap
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === 'timer' })}
                                    onClick={() => this.setState({ activeTab: 'timer' })}
                                >
                                    Timer
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="seatmap">
                                {adminStore.boundedLocations.map((loca) => <div key={loca._id}>
                                    <h3 className="my-3 bg-success text-light">{loca?.room_name}</h3>
                                    {/* <ComputersContainer computers={loca.computers} editable={false} /> */}
                                    <Container xs={4} sm={6} lg={9} className="my-4 h-75vh position-relative mb-5 d-inline-block" >
                                        <StageComponent
                                            key={"stage-" + loca._id}
                                            stageId={"stage-" + loca._id}
                                            allowEdit={false}
                                            stageRef={this.myRef}
                                            layerRef={this.myRef}
                                            field={loca}
                                            handleClickOnComputer={() => { }}
                                        />
                                    </Container>
                                </div>)}
                            </TabPane>
                            <TabPane tabId="timer">
                                {(() => {
                                    const todayStart = moment().startOf('day').valueOf(); // ms
                                    const todayEnd = moment().endOf('day').valueOf(); // ms
                                    const todaysExams = armedExam.filter(waiter => {
                                        // Parse using moment with known format
                                        const start = moment(waiter.time_start, "YYYY-MM-DD HH:mm:ss").valueOf();
                                        
                                        const inRange = start >= todayStart && start <= todayEnd;
                                        // console.log(`[Filter] Exam: ${waiter._id} Start: ${new Date(start)} InRange: ${inRange}`);
                                        return inRange;
                                    });
                                    // console.log(todaysExams.length);
                                    if (todaysExams.length == 0) {
                                        return (
                                            <div className="text-center my-5">
                                                <h4>No exams scheduled for today</h4>
                                                <p className="text-muted">Try reloading to see if any have been added.</p>
                                                <Button
                                                    color="primary"
                                                    onClick={() => {
                                                        console.log("[Timer Tab] Reloading exams...");
                                                        this.props.adminStore.examFetchScreenMode();
                                                    }}
                                                >
                                                    Reload Exams
                                                </Button>
                                            </div>
                                        );
                                    }

                                    return todaysExams.map((waiter, i) => (
                                        <TimerItem
                                            key={i}
                                            exam={waiter}
                                            onPlayClicked={() => this.handleTimerPlayClick(waiter)}
                                            onStopClicked={() => this.handleTimerStopClick(waiter)}
                                            onResetClicked={() => this.handleTimerResetClick(waiter)}
                                            onOvertimeClicked={() => this.handleTimerOvertimeClick(waiter)}
                                        />
                                    ));
                                })()}
                            </TabPane>
                        </TabContent>
                    </Col>
                </Row>

                <Modal isOpen={!!overtimeTarget}>
                    <ModalHeader>Tambah Waktu</ModalHeader>
                    <Form onSubmit={(e) => this.handleTimerOvertimeAction(e)}>
                        <ModalBody>
                            <p>
                                Tambah waktu untuk ujian:
                                <b> {overtimeTarget?.lecture?.lecture_code} {overtimeTarget?.shift ? (" SHIFT-" + overtimeTarget?.shift) : ""}</b>
                            </p>

                            <Label>
                                Jumlah menit yang ingin ditambahkan:
                            </Label>
                            <Input name="overtimeMin" id="overtimeMin" onChange={(e) => this.setState({ overtimeAmount: e.currentTarget.value })} value={overtimeAmount} />
                        </ModalBody>
                        <ModalFooter>
                            <Button onClick={() => this.setState({ overtimeTarget: undefined })} type="button" color="secondary">Batal</Button>
                            <Button type="submit" color="warning">Tambah</Button>
                        </ModalFooter>
                    </Form>
                </Modal>
            </Container >
        )
    }

    renderLoaderScreen() {
        return (<Container>
            <Row className="h-100vh align-items-center justify-content-center text-center">
                <Col>
                    <Spinner />
                    <p className="lead">Mengontak Server...</p>
                </Col>
            </Row>
        </Container>)
    }

    renderErrorScreen(message, children) {
        return (<Container>
            <Row className="h-100vh align-items-center justify-content-center text-center">
                <Col>
                    <h3>Whoops,</h3>
                    <p className="lead">{message}</p>
                    <div>{children}</div>
                </Col>
            </Row>
        </Container>)
    }
}

export default (inject("adminStore")(observer(TimerList)))
